import { Form, Formik, FormikProps, FormikValues } from 'formik';
import * as Yup from 'yup';
import { Typography } from '@mui/material';
import { RefObject } from 'react';
import { IFormFieldConfig } from '@shared/components/FormFieldsConstructor';
import { FileUploadForm } from '../../shared/UploadFileForm';

interface UploadRowProps<T> {
  title: string;
  initialValues: T;
  validationSchema: Yup.AnyObjectSchema;
  onSubmit: (values: T) => Promise<void>;
  formConfig: IFormFieldConfig<T>[];
  formikRef?: RefObject<FormikProps<T>>;
}

export const UploadRow = <T extends FormikValues & { document : File }>({
  title,
  initialValues,
  validationSchema,
  onSubmit,
  formConfig,
  formikRef
}: UploadRowProps<T>) => (
  <>
    <Typography 
      variant="h3" 
      sx={{ pr: '10px', mt: '16px' }}
    >
      {title}
    </Typography>

    <Formik 
      enableReinitialize
      innerRef={formikRef}
      initialValues={initialValues} 
      validationSchema={validationSchema} 
      onSubmit={onSubmit}
    >
      {({ handleSubmit, values, setFieldValue }) => (
        <Form onSubmit={handleSubmit}>
          <FileUploadForm 
            value={values} 
            setFieldValue={setFieldValue} 
            formConfig={formConfig} 
          />
        </Form>
      )}
    </Formik>
  </>
);